/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

export const getFormattedTime = (timeInMs) => {
    if (timeInMs <= 0) return false;
    return new Date(timeInMs).toLocaleString();
};

export const getFormattedLabels = (timeInMs) => {
    if (timeInMs <= 0) return false;
    else timeInMs = new Date(timeInMs)
    return `${timeInMs.getHours()}:${timeInMs.getMinutes() || "00"}`;
};